package com.ustadmobile.core.db.dao

import com.ustadmobile.lib.db.entities.LanguageVariant
import kotlin.String

public actual abstract class LanguageVariantDao : BaseDao<LanguageVariant> {
  public actual abstract fun findByCode(countryCode: String): LanguageVariant?
}
